import { Modal } from '@app-components/modal/modal.component'
import { addClasses, removeClasses, touchElement } from 'lambda-dom'
import { makeUrlForQrCode, has3DModel, makeArUrl } from '../services/colijn-model.service'
import { threedViewerConfig } from '../../config/colijn.config'

const arNotAvailableModal = Modal.create('ar-not-available-modal')

export async function makeThreedViewer(sku: string): Promise<any> {
    const hasModel = await has3DModel(sku)

    if (! hasModel) {
        return
    }

    touchElement('#threed-buttons-container', addClasses('active'))

    setQrCodeUrl()
    handleQrcodeUrl(sku)
    determineArButtonBehaviour(sku)
    setListenersForModalButtons()

    const threedViewerButton = document.querySelector('#threed-viewer-modal-button')

    threedViewerButton?.addEventListener('click', (e: Event) => {
        e.preventDefault()
        loadColijnThreedViewer(sku)
    })
}

function loadColijnThreedViewer(sku: string): void {
    const threeDContainer = document.querySelector<HTMLElement>('#threed-model-container')

    if (threeDContainer) {
        threeDContainer.setAttribute('sku', sku)
        threeDContainer.setAttribute('settings', JSON.stringify(threedViewerConfig))

        // Timeout because of a dialog element can be added to the DOM by threedconfigurator-standalone.bundle.min.js
        setTimeout(() => {
            const colijnShowsError = document.querySelector('.cdk-overlay-container')

            if (! colijnShowsError) {
                Modal.create('threed-viewer-modal').show()
                return
            }
        }, 500)
    }
}

function determineArButtonBehaviour(sku: string): void {
    const arButton  = document.querySelector<HTMLAnchorElement>('#ar-button')
    const isDesktop = window.innerWidth > 640
    const isIOS     = ! (window as any).MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent)

    if (! arButton) {
        return
    }

    if (isDesktop) {
        arButton.addEventListener('click', () => arNotAvailableModal.show())
    } else if (isIOS) {
        arButton.addEventListener('click', () => openARModelProgrammatically(makeArUrl(sku)))
    } else {
        arButton.href = makeArUrl(sku)
    }
}

function setListenersForModalButtons(): void {
    const closeArModalBtn = document.querySelector('#close-ar-not-available-modal')

    closeArModalBtn?.addEventListener('click', () => arNotAvailableModal.hide())

    const close3dSidebarBtn = document.querySelectorAll('[data-close-threed-sidebar]')

    close3dSidebarBtn?.forEach((el: HTMLElement) => el.addEventListener('click', () => {
        touchElement('#threed-sidebar', removeClasses('open'))
        touchElement('#threed-sidebar-overlay', removeClasses('open'))
    }))

    const open3dSidebarBtn = document.querySelector('[data-open-threed-sidebar]')

    open3dSidebarBtn?.addEventListener('click', () => {
        touchElement('#threed-sidebar', addClasses('open'))
        touchElement('#threed-sidebar-overlay', addClasses('open'))
    })
}

function setQrCodeUrl(): void {
    const qrCode = document.querySelector<HTMLImageElement>('#ar-qr-code')
    if (qrCode) {
        qrCode.src = makeUrlForQrCode()
    }
}

function handleQrcodeUrl(sku: string): void {
    const openArModel         = new URLSearchParams(window.location.search).get('open-ar-model')
    const isMobile            = window.innerWidth <= 640
    const isIOS               = ! (window as any).MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const arButtonInsideModal = document.querySelector<HTMLAnchorElement>('#ar-button-modal--button')

    if (openArModel && isMobile && arButtonInsideModal) {
        if (isIOS) {
            arButtonInsideModal.addEventListener('click', (event: Event) => {
                event.preventDefault()
                openARModelProgrammatically(makeArUrl(sku))
            })
        } else {
            // @ts-ignore
            arButtonInsideModal.href = makeArUrl(sku)
        }

        Modal.create('ar-button-modal').show()
    }
}

function openARModelProgrammatically(modelUrl: string): void {
    const anchor = document.createElement('a')
    anchor.setAttribute('rel', 'ar')
    anchor.appendChild(document.createElement('img'))
    anchor.setAttribute('href', modelUrl)
    anchor.click()
}
